import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";
import App from "./App";
import Store from "./Store";
import { unregister } from "./registerServiceWorker";
import "./index.css";
import "./custom.css";

ReactDOM.render(<App />, document.getElementById("root"));
unregister();



// WEBPACK FOOTER //
// ./src/index.js